import { LoadingSpinner as SonansLoadingSpinner } from '@sonans/components'

export function LoadingSpinner() {
    return (
        <div className="w-full h-[300px] flex justify-center items-center">
            <SonansLoadingSpinner />
        </div>
    )
}
